import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import 'font-awesome/css/font-awesome.min.css';
import 'simple-line-icons/css/simple-line-icons.css';
import './scss/style.scss';
import './scss/core/_dropdown-menu-right.scss';

ReactDOM.render(<App />,document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js